import axios from 'axios';
import { AnalyzeBusinessRequest, AnalysisResponse } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const analyzeBusiness = async (
  data: AnalyzeBusinessRequest
): Promise<AnalysisResponse> => {
  const response = await api.post<AnalysisResponse>(
    '/api/business-analysis/analyze',
    data
  );
  return response.data;
};

export interface PromptConfig {
  openai: {
    systemPrompt: string;
    userPrompt: string;
  };
  perplexity: {
    systemPrompt: string;
    userPrompt: string;
  };
}

export interface PromptConfigResponse {
  config: PromptConfig;
  requiredTags: string[];
}

export interface UpdatePromptRequest {
  provider: 'openai' | 'perplexity';
  type: 'systemPrompt' | 'userPrompt';
  prompt: string;
}

export interface UpdatePromptResponse {
  success: boolean;
  message: string;
  config?: PromptConfig;
}

export const getPromptConfig = async (): Promise<PromptConfigResponse> => {
  const response = await api.get<PromptConfigResponse>('/api/prompt-config');
  return response.data;
};

export const updatePrompt = async (
  data: UpdatePromptRequest
): Promise<UpdatePromptResponse> => {
  const response = await api.put<UpdatePromptResponse>('/api/prompt-config', data);
  return response.data;
};

